import React from "react";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";
import IOSInputIsFocusedProvider from "frontend/context/DevicesContext/implementations/IOSInputIsFocusedContext/index.js";

// components
import SearchBar from "./SearchBar";

// This is the default variation
// all the default styles of the SearchBar reflect the HeaderSearchBar
export const HeaderSearchBar = props => {
    const { isDarkMode } = useSiteHeader();

    return (
        <IOSInputIsFocusedProvider isDarkMode={isDarkMode} height={40}>
            <SearchBar isDarkMode={isDarkMode} {...props} />
        </IOSInputIsFocusedProvider>
    );
};

export default HeaderSearchBar;
